import { render, staticRenderFns } from "./bolt_retail_general_tab.vue?vue&type=template&id=f05a7b7e&scoped=true&"
import script from "./bolt_retail_general_tab.vue?vue&type=script&lang=js&"
export * from "./bolt_retail_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05a7b7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f05a7b7e')) {
      api.createRecord('f05a7b7e', component.options)
    } else {
      api.reload('f05a7b7e', component.options)
    }
    module.hot.accept("./bolt_retail_general_tab.vue?vue&type=template&id=f05a7b7e&scoped=true&", function () {
      api.rerender('f05a7b7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/bolt_retail/location/tabs/bolt_retail_general_tab.vue"
export default component.exports